<div class="d-flex flex-column kng-footer">
  <footer id="aem-footer-wrapper">
    <div id="externaHtmlHandler" [innerHTML]="state.footercontent.unifiedFooter | safeHtml"></div>
  </footer>
</div>
